/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteSegmentIntegrationsClient } from '../fn/segment-integration/delete-segment-integrations-client';
import { DeleteSegmentIntegrationsClient$Params } from '../fn/segment-integration/delete-segment-integrations-client';
import { Empty } from '../models/empty';
import { getSegmentIntegrations } from '../fn/segment-integration/get-segment-integrations';
import { GetSegmentIntegrations$Params } from '../fn/segment-integration/get-segment-integrations';
import { HalJson } from '../models/hal-json';
import { IntegrationStatusResponse } from '../models/integration-status-response';
import { postClientSegmentIntegrations } from '../fn/segment-integration/post-client-segment-integrations';
import { PostClientSegmentIntegrations$Params } from '../fn/segment-integration/post-client-segment-integrations';
import { postSegmentIntegrations } from '../fn/segment-integration/post-segment-integrations';
import { PostSegmentIntegrations$Params } from '../fn/segment-integration/post-segment-integrations';
import { postSegmentIntegrationsSettings } from '../fn/segment-integration/post-segment-integrations-settings';
import { PostSegmentIntegrationsSettings$Params } from '../fn/segment-integration/post-segment-integrations-settings';

@Injectable({ providedIn: 'root' })
export class SegmentIntegrationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postSegmentIntegrationsSettings()` */
  static readonly PostSegmentIntegrationsSettingsPath = '/segment-integrations/settings';

  /**
   * Save segment integration settings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postSegmentIntegrationsSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postSegmentIntegrationsSettings$Response(params: PostSegmentIntegrationsSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<HalJson>> {
    return postSegmentIntegrationsSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * Save segment integration settings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postSegmentIntegrationsSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postSegmentIntegrationsSettings(params: PostSegmentIntegrationsSettings$Params, context?: HttpContext): Observable<HalJson> {
    return this.postSegmentIntegrationsSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<HalJson>): HalJson => r.body)
    );
  }

  /** Path part for operation `getSegmentIntegrations()` */
  static readonly GetSegmentIntegrationsPath = '/segment-integrations/integrations';

  /**
   * Get segment integration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSegmentIntegrations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSegmentIntegrations$Response(params: GetSegmentIntegrations$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegrationStatusResponse>> {
    return getSegmentIntegrations(this.http, this.rootUrl, params, context);
  }

  /**
   * Get segment integration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSegmentIntegrations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSegmentIntegrations(params: GetSegmentIntegrations$Params, context?: HttpContext): Observable<IntegrationStatusResponse> {
    return this.getSegmentIntegrations$Response(params, context).pipe(
      map((r: StrictHttpResponse<IntegrationStatusResponse>): IntegrationStatusResponse => r.body)
    );
  }

  /** Path part for operation `postSegmentIntegrations()` */
  static readonly PostSegmentIntegrationsPath = '/segment-integrations/integrations';

  /**
   * Create segment integration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postSegmentIntegrations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postSegmentIntegrations$Response(params: PostSegmentIntegrations$Params, context?: HttpContext): Observable<StrictHttpResponse<HalJson>> {
    return postSegmentIntegrations(this.http, this.rootUrl, params, context);
  }

  /**
   * Create segment integration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postSegmentIntegrations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postSegmentIntegrations(params: PostSegmentIntegrations$Params, context?: HttpContext): Observable<HalJson> {
    return this.postSegmentIntegrations$Response(params, context).pipe(
      map((r: StrictHttpResponse<HalJson>): HalJson => r.body)
    );
  }

  /** Path part for operation `postClientSegmentIntegrations()` */
  static readonly PostClientSegmentIntegrationsPath = '/segment-integrations/integrations/clients/{clientId}';

  /**
   * Create frontend client segment integration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postClientSegmentIntegrations()` instead.
   *
   * This method doesn't expect any request body.
   */
  postClientSegmentIntegrations$Response(params: PostClientSegmentIntegrations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postClientSegmentIntegrations(this.http, this.rootUrl, params, context);
  }

  /**
   * Create frontend client segment integration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postClientSegmentIntegrations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postClientSegmentIntegrations(params: PostClientSegmentIntegrations$Params, context?: HttpContext): Observable<void> {
    return this.postClientSegmentIntegrations$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteSegmentIntegrationsClient()` */
  static readonly DeleteSegmentIntegrationsClientPath = '/segment-integrations/integrations/clients/{clientId}';

  /**
   * Create segment integration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSegmentIntegrationsClient()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSegmentIntegrationsClient$Response(params: DeleteSegmentIntegrationsClient$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
    return deleteSegmentIntegrationsClient(this.http, this.rootUrl, params, context);
  }

  /**
   * Create segment integration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSegmentIntegrationsClient$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSegmentIntegrationsClient(params: DeleteSegmentIntegrationsClient$Params, context?: HttpContext): Observable<Empty> {
    return this.deleteSegmentIntegrationsClient$Response(params, context).pipe(
      map((r: StrictHttpResponse<Empty>): Empty => r.body)
    );
  }

}
